import { deeplinkUrl } from "./url"
import { deeplinkMShopAndroid, deeplinkMshopIos } from "./mshop"
import { deeplinkWin10Edge, deeplinkWin10Firefox, deeplinkWin10FirefoxLegacy, deeplinkWin10Chrome } from "./download"

export type DeeplinkHandlerInput = { url: string; fallbackUrl?: string }

export const processDeeplinkFor = {
  URL: deeplinkUrl,
  MSHOP_ANDROID: deeplinkMShopAndroid,
  MSHOP_IOS: deeplinkMshopIos,
  IOS_LEGACY: deeplinkUrl,
  WIN10_EDGE: deeplinkWin10Edge,
  WIN10_FIREFOX: deeplinkWin10Firefox,
  WIN10_FIREFOX_LEGACY: deeplinkWin10FirefoxLegacy,
  WIN10_CHROME: deeplinkWin10Chrome,
}
